export interface ChangePasswordDto {
  currentPassword: string,
  password: string,
  confirmPassword: string,
}

export const changePasswordInit: ChangePasswordDto = { currentPassword: '', password: '', confirmPassword: '' };